<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
                        <el-row>
                            <el-col>
                                <span class="cs-title">真留数据实时搜索</span>
                                <studyAbroadSalesQueryList :isActive="true" />
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>


<script>
import navigator from "../../components/navigator";
import studyAbroadSalesQueryList from "../../components/salesQuery/studyAbroadSalesQueryList";

export default {
    components: {
        navigator,
        studyAbroadSalesQueryList
    },
    data() {
       return {
           
       };
    },
    created() {
       
    },
    methods: {
       
    }
};
</script>



// WEBPACK FOOTER //
// src/page/studyAbroad/salesQuery.vue